import Vue from 'vue'
import Vuex from 'vuex'
import common from './module/common.js'
import log from './module/log.js'
import player from './module/player.js'
import syncRoom from './module/syncRoom.js'
import getters from './getters.js'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        common, // 公共属性
        log, // 日志模块
        player,
        syncRoom,
    },
    getters
})

export default store
